import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoadingState } from '../model/loading-state.interface';

/**
 * Serviço responsável por gerenciar o estado de carregamento e suas animações.
 */
@Injectable({
  providedIn: 'root'
})
export class LoadingCirculoService {

  // Subjects para gerenciar o estado de carregamento
  private loadingStateDisplayEfectsSubject = new BehaviorSubject<boolean>(false);
  private loadingStateDisplaySubject = new BehaviorSubject<boolean>(false);
  private loadingStateSubject = new BehaviorSubject<LoadingState>({
    fillPercentage: 0,
    background: '#001345',
    description: '',
    icon: '',
  });

  // Observables para expor o estado de carregamento
  public loadingStateDisplayEfects$: Observable<boolean> = this.loadingStateDisplayEfectsSubject.asObservable();
  public loadingStateDisplay$: Observable<boolean> = this.loadingStateDisplaySubject.asObservable();
  public loadingState$: Observable<LoadingState> = this.loadingStateSubject.asObservable();

  // Timeout para controle de exibição do carregamento
  private loadingTimeout: any;
  public isLoading: boolean = false;
  public displayloading: boolean = false;

  constructor() { }

  /**
   * Atualiza o estado de carregamento com novos valores.
   * @param state Estado parcial de carregamento a ser atualizado.
   */
  public updateLoadingState(state: Partial<LoadingState>) {
    const currentState = this.loadingStateSubject.value;
    this.loadingStateDisplayEfectsSubject.next(true);
    if (currentState.fillPercentage == 0) {
      this.loadingStateSubject.next({ ...currentState, ...state });
    } else {
      // O setTimeout é para aplicação de efeitos
      setTimeout(() => {
        this.loadingStateSubject.next({ ...currentState, ...state });
      }, 1000);
    }
  }

  /**
   * Inicia o estado de carregamento e define um timeout para ocultá-lo após 60 segundos.
   */
  public startLoading(): void {
    this.loadingStateDisplaySubject.next(true);

    // Limpa qualquer timeout existente para evitar múltiplos temporizadores
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
    }

    // Define um timeout para ocultar automaticamente o carregamento após 60 segundos
    this.loadingTimeout = setTimeout(() => {
      this.stopLoading();
    }, 120000); // 120 segundos
  }

  /**
   * Para o estado de carregamento e limpa o timeout se chamado manualmente.
   */
  public stopLoading(): void {
    setTimeout(() => {
      this.loadingStateDisplaySubject.next(false);
    }, 2000);

    // Limpa o timeout se stopLoading for chamado manualmente
    if (this.loadingTimeout) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = null;
    }
  }
}